import { Component, OnInit } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Router } from '@angular/router';

//import 'rxjs/Rx';
//import { Observable } from 'rxjs/Rx';
//import { CollapseDirective } from 'ng2-bootstrap';

import { Enquiry } from './model';
import { DataService } from "./api.data.service";
import { EnquiryService } from "./api.service";

import { Location } from '@angular/common';

@Component({
    selector: 'my-app',
    template: require('./app.component.html'),
    providers: [DataService, EnquiryService],
    styleUrls: require['rtimeapp.css'],
})
export class AppComponent implements OnInit {
    public navbarIsCollapsed: boolean = true;

    constructor(private router: Router, location: Location) {
        router.events.subscribe((val) => {
            this.navbarIsCollapsed = true;
        });

        location.go(location.path());
    }

    ngOnInit() {
      
    }

    public collapseNavbarOnBlur() {
        //If the user clicked on a menu item, we need this short delay before the navbar collapses otherwise the route doesnt activate
        setTimeout(() => {
            this.navbarIsCollapsed = true;
        }, 250);
    }
}
    



/** WEBPACK FOOTER **
 ** ./src/app/app.component.ts
 **/